export default __webpack_public_path__ + "static/media/checklist.64b6953e.png";